export const languageMap = {
    es: ["es-PR", "en-US"],
    en: "en-US",
    "pl-PL": "pl-PL",
    "fr-FR": ["fr-FR", "en-US"],
    "ru-RU": ["ru-RU", "en-US"],
};